import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastrService: ToastrService) {
  }


  async presentErrorToast(error: any, logicalError?: boolean) {

    var errorMessage: string = error?.error?.errors[0];
    if (logicalError) {
      this.toastrService.error(error, '', {
        toastClass: 'ngx-toastr no-icon-toast error-toast',
      });
    }
    else if (errorMessage) {
      this.toastrService.error(errorMessage, '', {
        toastClass: 'ngx-toastr no-icon-toast error-toast',
      });
    }

    //Todo: language handler
    // const language = localStorage.getItem("language");
    // if (language) {
    //   errorMessage = language === 'en' ? error?.error?.errors[0] : error?.error?.errors[1];
    // }
  }

  async presentSuccessToast(message: string) {
    this.toastrService.success(message, '', {
      toastClass: 'ngx-toastr no-icon-toast success-toast',
    });
  }

}
